import React, { ReactElement, useMemo } from 'react';

import TextArea from 'antd/lib/input/TextArea';

import type { ConfigurationUpdateRequestDto } from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import { FormInputProps } from 'components/BaseForm/types';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import {
  ConfigurationFormData,
  mapToConfigurationFormData,
} from './configurationUpdateMapper';

interface FormEditionProps {
  close: () => void;
  initialValues: ConfigurationUpdateRequestDto;
  title: string;
  submit: (newValues: ConfigurationUpdateRequestDto) => void;
  isSubmitting: boolean;
  readOnly: boolean;
  fullName: string;
}

export default function FormEdition({
  close,
  initialValues,
  title,
  submit,
  isSubmitting,
  readOnly,
  fullName,
}: Readonly<FormEditionProps>): ReactElement {
  const extendedInitialValues: ConfigurationFormData =
    mapToConfigurationFormData(initialValues, fullName);

  const inputs: Array<FormInputProps<ConfigurationFormData, void>> = useMemo(
    () => [
      {
        name: 'fullName',
        label: 'Nom',
        required: false,
        disabled: true,
      },
      {
        name: 'newValue',
        label: 'Valeur',
        required: false,
        disabled: readOnly,
        render: () => <TextArea placeholder={FormPlaceholders.Input} />,
      },
      {
        name: 'newDescription',
        label: 'Description',
        required: false,
        disabled: readOnly,
        render: () => <TextArea placeholder={FormPlaceholders.Input} />,
      },
    ],
    [readOnly],
  );

  const handleSubmit = (formData: ConfigurationFormData) => {
    const { newValue, newDescription } = formData;

    const updateData: ConfigurationUpdateRequestDto = {
      newValue: newValue?.trim() || null,
      newDescription: newDescription?.trim() || null,
    };

    submit(updateData);
  };

  return (
    <>
      <h3 className="mainTitle" id="modal-title">
        {title}
      </h3>
      <BaseForm<ConfigurationFormData, void>
        initialValues={extendedInitialValues}
        onCancel={close}
        onSubmit={handleSubmit}
        inputs={inputs}
        isSubmitting={isSubmitting}
        labelCol={{ span: CSSUtils.mediumWrapperCol }}
        wrapperCol={{ span: CSSUtils.fullWidthCol }}
      />
    </>
  );
}
